export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isArray.js
// module id = ./node_modules/redux-actions/es/utils/isArray.js
// module chunks = 6 9 11